import Helpers from '../../theme/helpers.js';
import SweetScroll from 'sweet-scroll';

export default class Accordion {
    constructor() {
        this.init();
        this.current = false;
    }

    init() {
        const elements = document.querySelectorAll( '[data-accordion="element"]' );
        const helpers = new Helpers;
        const scroller = new SweetScroll();

		elements.forEach( ( element ) => {
			const items = element.querySelectorAll( '[data-accordion="item"]' );

            items.forEach( ( item ) => {
                const trigger = item.querySelector( '[data-accordion="trigger"]');
                const target = item.querySelector( '[data-accordion="target"]');

                trigger.addEventListener( 'click', ( e ) => {
                    if ( this.current !== false ) {
                        this.current.classList.remove( 'active' );
                        helpers.slideUp( this.current.querySelector( '[data-accordion="target"]'), 250 );
                        this.current._tippy.enable();
                    }

                    if ( this.current !== item ) {
                        item.classList.add( 'active' );
                        helpers.slideDown( target, 250, 'flex' );
                        item._tippy.disable();

                        setTimeout( () => {
                            scroller.toElement(item);
                        }, 250);

                        this.current = item;
                    } else {
                        this.current = false;

                        setTimeout( () => {
                            scroller.toElement(element);
                        }, 250);
                    }
                } );
            } );
		} );
    }
}